
import { useDispatch, useSelector } from "react-redux";
import { Box, TextField } from "@mui/material";
import MaterialTable from "material-table"
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { AddBusinessUnitAction, UpdateBusinessUnitAction, DeleteBusinessUnitAction } from "../../../../../store/Ancillary/BusinessUnit/Action";

const BusinessUnit = () => {
    const dispatch = useDispatch()
    const { businessunitData } = useSelector(state => state?.AncillaryReducer?.BusinessUnitReducer);

    return (
        <Box>
            <MaterialTable
                columns={[
                    {
                        title: "Name", 
                        cellStyle: { padding: "5px 10px 0px 13px" },
                        field: "name", 
                        validate: (rowData) => {
                            if (rowData?.tableData && rowData?.tableData?.editing === "delete") {
                                return ""; 
                            }
                            if (!rowData?.name?.trim()) {
                            return "Name cannot be empty";
                            }
                            return "";
                        },
                        editComponent: props => {
                          return(
                            <Box sx={{ width: "90%" }}>
                            <TextField
                                required={true}
                                variant="standard"
                                fullWidth
                                value={props?.value}
                                onChange={e => props.onChange(e.target.value)}
                            />
                            </Box>
                        )}
                    },
                    {
                        title: "BU Alias",
                        cellStyle: { padding: "5px 10px 0px 13px" },
                        field: "alias_name",
                        validate: (rowData) => {
                            if (rowData?.tableData && rowData?.tableData?.editing === "delete") {
                                return ""; 
                            }
                            if (!rowData?.alias_name?.trim()) {
                            return "Alias cannot be empty";
                            }
                            return "";
                        },
                        editComponent: (props) => {
                            return (
                            <Box sx={{ width: "90%" }}>
                            <TextField
                                required={true}
                                variant="standard"
                                fullWidth
                                value={props?.value}
                                onChange={(e) => props.onChange(e.target.value)}
                                />
                            </Box>
                            );
                        },
                        },
                ]}
                data={businessunitData || []}
                icons={{
                    Add: () => <AddIcon />,
                    Edit: () => <EditIcon />,
                    Delete: () => <DeleteIcon />
                }}
                editable={{
                    onRowAdd: (newRow) =>
                        new Promise((resolve, reject) => {
                            if (!newRow?.name?.trim() || !newRow?.alias_name?.trim()) {
                                return reject();
                            }
                            dispatch(AddBusinessUnitAction(newRow))
                            setTimeout(() => resolve(), 500);
                        }),
                    onRowUpdate: (newRow, oldRow) =>
                        new Promise((resolve, reject) => {
                            if (!newRow?.name?.trim() || !newRow?.alias_name?.trim()) {
                                return reject();
                            }
                            dispatch(UpdateBusinessUnitAction(newRow))
                            setTimeout(() => resolve(), 500);
                        }),
                    onRowDelete: (selectedRow) =>
                        new Promise((resolve, reject) => {
                            dispatch(DeleteBusinessUnitAction({ businessunit_id: `{${selectedRow?.businessunit_id}}` }))
                            setTimeout(() => resolve(), 1000);
                        }),
                }}
                options={{
                    maxBodyHeight: 220,
                    rowStyle: { fontSize: "13px" },
                    headerStyle: { padding: "0px 10px", fontWeight: "bold" },
                    sorting: true,
                    search: false,
                    searchFieldAlignment: "right",
                    searchAutoFocus: true,
                    searchFieldVariant: "standard",
                    filtering: false,
                    paging: false,
                    selection: false,
                    actionsColumnIndex: -1,
                    grouping: false,
                    addRowPosition: "first",
                }}
                title=""
            />
        </Box>
    );
}
export default BusinessUnit;